/**
 * 作業時間ドロップダウンの選択肢（分）。
 *
 * 実績分布（`unified_requests` の work_minutes > 0、7,824 件）の上位値に合わせてある。累積では
 * 20 分以下で 48%、60 分以下で 79%、120 分以下で 91%、300 分以下で 99% を占めるので、この 10 個で
 * ほぼ全ての依頼を表現できる。
 *
 * **40 を必ず含めること**: 状態変更 / SQL レビューの中央値が 40 分で、選択肢に無いと
 * `opsWorkMinutesSuggestion` が返す目安をそのまま選べなくなる。
 * @graph-connects none
 */
export const OPS_WORK_MINUTES_OPTIONS = [
    10, 20, 30, 40, 60, 90, 120, 180, 240, 300,
];
/**
 * 種別ごとの作業時間の目安（分）。`unified_requests` の記録済み中央値（7,824 件）。
 *
 * 調査依頼だけ 60 分で、データ修正（20 分）の 3 倍ある。全体の平均（57.5 分）は 120 分以上の
 * 長い尾に引っ張られた値で代表値にならないため、中央値を使う。
 *
 * **この母集団は純粋な実測ではない。** legacy シート側の `work_minutes` は customer-success MCP の
 * `close_ops_request` が「会話の経過から概算」して 20 分刻みに丸めて書いた値を多く含む
 * （実際、上位値が 20 / 40 / 60 / 80 / 100 に集中している）。したがってこの目安は「これまで
 * 記録されてきた値の真ん中」であって、計測された所要時間の中央値ではない。
 * @graph-connects none
 */
const CATEGORY_MEDIAN_MINUTES = {
    調査依頼: 60,
    状態変更: 40,
    データ修正: 20,
    SQLレビュー: 40,
    Fatal: 20,
    // 実績がまだ無い種別。アラートの確認だけで閉じるものが大半と見込み、データ修正と同じ最小帯に置く。
    システムオペレーション: 20,
};
/**
 * 種別から作業時間の目安（分）を返す。全ての `OpsCategory` が目安を持つ。
 *
 * **入力欄の初期値にはしない**（選ばれていない目安として隣に出すだけ）。自動で値を入れると、
 * 誰も確認していない数字が記録として BQ に載る。legacy 側は既に AI 概算が混ざっているので、
 * native 側まで自動入力にすると「人が記録した値」の母集団が一つも残らなくなる。
 * @graph-stack ops-core
 * @graph-domain Operations
 * @graph-business 種別ごとの作業時間の目安（分、記録済み中央値）を返す。入力の初期値ではなく参考値として表示する
 * @graph-connects none
 */
export function opsWorkMinutesSuggestion(category) {
    return CATEGORY_MEDIAN_MINUTES[category];
}
/**
 * 作業時間の入力値が保存してよい値かを判定する。正の整数のみ許可する。
 *
 * 選択肢外の値も許す（人が実測を直接入れる場合がある）。0 と負数は「未記録」と区別できないので
 * 弾き、未記録は null で表す。
 * @graph-stack ops-core
 * @graph-domain Operations
 * @graph-business 作業時間（分）の保存可否を判定する。正の整数のみ許可し、0 / 負数 / 非整数は拒否する
 * @graph-connects none
 */
export function isValidOpsWorkMinutes(minutes) {
    return Number.isInteger(minutes) && minutes > 0;
}
//# sourceMappingURL=work-minutes.js.map